import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOnboardingStage, useSetOnboardingStage, useCryptoOnboardingComplete, useSetStripeOnboardingStatus } from '../state';
import fetchWithToken, { updateOnboardingStage } from '../services';
import Loading from './Loading';

const CheckStripeOnboardingStatus = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const onboardingStage = useOnboardingStage();
    const setOnboardingStage = useSetOnboardingStage();
    const cryptoOnboardingComplete = useCryptoOnboardingComplete();
    const setStripeOnboardingStatus = useSetStripeOnboardingStatus();

    useEffect(() => {
        const checkStatus = async () => {
            const searchParams = new URLSearchParams(location.search);
            const returnFromStripe = searchParams.get('returnFromStripe');

            // if (!returnFromStripe) {
            //     navigate('/');
            //     return;
            // }

            try {
                const response = await fetchWithToken('/check-stripe-onboarding', {
                    method: 'POST'
                });

                if (!response.ok) {
                    throw new Error('Failed to check Stripe onboarding status');
                }

                const data = await response.json();
                console.log('Data returned by check stripe onboarding endpoint: ', data);
                const status = data.onboardingStatus;
                setStripeOnboardingStatus(status);
                console.log('status: ', status);
                console.log('onboardingStage: ', onboardingStage);

                // Only proceed if Stripe onboarding is complete
                if (status === 'complete') {
                    if (onboardingStage === 'fiat-onboarding' || (onboardingStage === 'fiat-crypto-onboarding' && cryptoOnboardingComplete)) {
                        await updateOnboardingStage('complete');
                        setOnboardingStage('complete');
                        console.log('onboarding stage updated to complete');
                        // const newUrl = window.location.pathname;
                        // window.history.replaceState({}, '', newUrl);
                    }
                }

                setTimeout(() => {
                    navigate('/', { replace: true });
                }, 500);
            } catch (error) {
                console.error('Error checking Stripe onboarding status:', error);
                setTimeout(() => {
                    navigate('/error', { replace: true });
                }, 500);
            }
        };

        checkStatus();
    }, []);

    return <Loading />;
};

export default CheckStripeOnboardingStatus;